import { h, Component, Fragment } from "preact";
import {FiltersRow, InputFilter, SelectRow} from "../utils/table-utils";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import {DateHelperFilter} from "../utils/form-utils";
import PrematchFeedService from "../../../services/prematch-feed";
import OddsPrint from "../../../services/oddsprint";
import {route} from "preact-router";
import AwrabetPrintOdds from '../../awrabet/desktop-components/print-odds.jsx';

/**
 * Questa è la stampaquote copiata e incollata da un altro template. Devo buttare il JSX qui dentro e uniformarlo al resto.
 * Non ho tempo e voglia. Non ci saranno altri componenti basati su questo, quindi sta bene così
 */
export default class PrintOdds extends AwrabetPrintOdds {

    render() {
        return <div>
            <div class="w-full">
                <div id="fn-top-filters" class="w-full panel bg-harif-800 border-b border-b-harif-950 text-white py-2">
                    <form class="flex">
                        <SelectRow
                            label={<span class="block text-xs"><Trans>Ordinamento</Trans></span>}
                            boxclass={"px-2 pb-1 w-44 flex-shrink-0 flex-grow-0"}
                            class={"px-2 py-1 rounded border bg-white text-black h-8 w-full"}
                            onChange={e => {
                                this.state.form.sort = e.currentTarget.value;
                                this.setState(this.state);
                            }}
                        >
                            <option value="1" selected={this.state.form.sort === '1'}><Trans>Evento</Trans></option>
                            <option value="2" selected={this.state.form.sort === '2'}><Trans>Data</Trans></option>
                            <option value="3" selected={this.state.form.sort === '3'}><Trans>Evento + Data</Trans>
                            </option>
                        </SelectRow>
                        <SelectRow
                            label={<span class="block text-xs"><Trans>Orientamento Stampa</Trans></span>}
                            boxclass={"px-2 pb-1 w-44 flex-shrink-0 flex-grow-0"}
                            class={"px-2 py-1 rounded border bg-white text-black h-8 w-full"}
                            onChange={e => {
                                this.state.form.ori = e.currentTarget.value;
                                this.setState(this.state);
                            }}
                        >
                            <option value="L" selected={this.state.form.ori === 'L'}><Trans>Orizzontale</Trans></option>
                            <option value="P" selected={this.state.form.ori === 'P'}><Trans>Verticale</Trans></option>
                        </SelectRow>
                        <DateHelperFilter
                            {...this.state.dateFilter}
                            class="px-2 py-1 rounded border bg-white text-black h-8"
                            onInput={
                                (dateFilter) => {
                                    this.state.dateFilter = dateFilter;
                                    this.setState(this.state);
                                }
                            }
                        />
                        <SelectRow
                            label={<span class="block text-xs"><Trans>Logo</Trans></span>}
                            boxclass={"px-2 pb-1 w-44 flex-shrink-0 flex-grow-0"}
                            class={"px-2 py-1 rounded border bg-white text-black h-8"}
                            onChange={e => {
                                this.state.form.logo = !this.state.form.logo;
                                this.setState(this.state);
                            }}
                        >
                            <option value={true} selected={this.state.form.logo}><Trans>Con Logo</Trans></option>
                            <option value={false} selected={!this.state.form.logo}><Trans>Senza logo</Trans></option>
                        </SelectRow>
                        <div class="grow"></div>
                        <div class="pb-1 flex h-full pt-2 items-end">
                            <a href="javascript:void(0);"
                               class="p-2 ml-5 bg-amber-500 text-black text-base rounded"
                               onClick={e => {
                                   this.state.outcomeselection = ['3', '152', '75', '149', '89'];
                                   this.setState(this.state);
                               }}>
                                <Trans>Scegli Principali <i class="fa fa-plus"/></Trans>
                            </a>
                        </div>
                        <div class="pb-1 flex h-full pt-2 pr-2 items-end">
                            <a href="javascript:void(0);"
                               class="p-2 ml-5 bg-amber-500 text-black text-base rounded"
                               onClick={e => this.performPDF()}>
                                <Trans>Genera PDF <i class="fa fa-search"/></Trans>
                            </a>
                        </div>
                    </form>
                </div>
                <div class="flex items-start justify-start p-2 gap-2">
                    <div class="w-full panel bg-harif-800 text-white rounded">
                        <div class="h-8 border-b border-harifzinc-900 text-white px-2 flex items-center text-sm">
                            <div><span class="text-harifzinc-400 font-bold text-base inline-block w-4 pl-1">1</span>
                                <span class="text-amber-500"><Trans>Scegli Nazione</Trans></span></div>
                        </div>
                        <ul class="p-3 text-sm">
                            {Object.values(this.state.schedules).map(
                                sport => <li>
                                    <div>
                                        <label class="flex items-center justify-center gap-1">
                                            <InputFilter
                                                type="checkbox"
                                                class=""
                                                checked={!!this.state.categoryselection[sport._id]}
                                                onInput={e => this.sportSelectionToggle(sport._id)}
                                            />
                                            <span class={"sporticon grow-0 sp_" + sport._id + ""}/>
                                            <span
                                                class="main-text-color inline-block py-1 w-full">{sport.name}</span>
                                        </label>
                                    </div>
                                    <ul class="pl-5 pb-3">
                                        {Object.values(sport.sub).map(
                                            category => <li>
                                                <div>
                                                    <label>
                                                        <InputFilter
                                                            type="checkbox"
                                                            class=""
                                                            checked={!!this.state.categoryselection[sport._id] && this.state.categoryselection[sport._id].indexOf(category._id) !== -1}
                                                            onInput={e => this.categorySelectionToggle(sport._id, category._id)}
                                                        />
                                                        {/* <span class={"scheduleflag ml-2 flag-" + category.id.split('/')[3]} /> */}
                                                        <span
                                                            class={"ml-2 inline-block w-4 mr-1 scheduleflag_pos rectangleFlag rectangleFlags_" + (category.label || category.name).toLowerCase().replace(/ /g, "")}
                                                            style="vertical-align:text-bottom"/>
                                                        <span
                                                            class="main-text-color inline-block py-1">{category.name}</span>
                                                    </label>
                                                </div>
                                            </li>
                                        )}
                                    </ul>
                                </li>
                            )}
                        </ul>
                    </div>
                    <div class="w-full panel bg-harif-800 text-white rounded">
                        <div class="h-8 border-b border-harif-900 text-white px-2 flex items-center text-sm">
                            <div><span class="text-harif-400 font-bold text-base inline-block w-4 pl-1">2</span>
                                <span class="text-amber-500"><Trans>Scegli Tornei</Trans></span></div>
                        </div>
                        {!!this.state.loading.tournaments && <p class="main-text-color text-center pt-5">
                            <i class="fa text-2xl fa-spin fa-spinner"/>
                        </p>}
                        <ul class="p-3 text-sm">
                            {!!Object.values(this.state.tournaments).length && <li>
                                <div>
                                    <label>
                                        <InputFilter
                                            type="checkbox"
                                            class=""
                                            checked={!!Object.values(this.state.tournamentselection).length}
                                            onInput={e => this.tournamentAllToggle()}
                                        />
                                        <span
                                            class="main-text-color inline-block py-1 px-2"><Trans>Tutti</Trans></span>
                                    </label>
                                </div>
                            </li>}
                            {!!this.state.tournaments && Object.entries(this.state.tournaments).map(
                                ([sportid, categories]) => <li>
                                    <div>
                                        <label>
											<span
                                                class="main-text-color py-1 px-2 flex items-center gap-1">
												<span class={"sporticon grow-0 sp_" + sportid + ""}
                                                      style="margin:0"/>
												<span>{this.state.sportnames[sportid]}</span>
											</span>
                                        </label>
                                    </div>
                                    <ul class="pl-5 pb-3">
                                        {Object.entries(categories).map(
                                            ([categoryname, tournaments]) => <li>
                                                <div>
                                                    <label>
                                                        <InputFilter
                                                            type="checkbox"
                                                            class=""
                                                            checked={!!this.state.tournamentselection[sportid] && !!this.state.tournamentselection[sportid][tournaments[0].pal]}
                                                            onInput={e => this.tournamentParentToggle(sportid, tournaments[0].pal, categoryname)}
                                                        />
                                                        {/* <span class={"scheduleflag ml-2 flag-" + tournaments[0].pal} /> */}

                                                        <span
                                                            class={"ml-2 scheduleflag_pos inline-block w-4 mr-1 rectangleFlag rectangleFlags_" + (categoryname).toLowerCase().replace(/ /g, "")}
                                                            style="vertical-align:text-bottom"/>
                                                        <span
                                                            class="main-text-color inline-block py-1">{categoryname}</span>
                                                    </label>
                                                </div>
                                                <ul class="pl-5 pb-1">
                                                    {tournaments.map(
                                                        tournament => <li>
                                                            <label>
                                                                <InputFilter
                                                                    type="checkbox"
                                                                    class=""
                                                                    checked={
                                                                        !!this.state.tournamentselection[sportid]
                                                                        && !!this.state.tournamentselection[sportid][tournament.pal]
                                                                        && this.state.tournamentselection[sportid][tournament.pal].indexOf(tournament.num) !== -1
                                                                    }
                                                                    onInput={e => this.tournamentSelectionToggle(sportid, tournament.pal, tournament.num)}
                                                                />
                                                                {/* <span class={"scheduleflag ml-2 flag-" + tournament.pal} /> */}
                                                                <span
                                                                    class={"ml-2 scheduleflag_pos inline-block w-4 mr-1 rectangleFlag rectangleFlags_" + (categoryname).toLowerCase().replace(/ /g, "")}
                                                                    style="vertical-align:text-bottom"/>
                                                                <span
                                                                    class="main-text-color inline-block py-1">{tournament.name}</span>
                                                            </label>
                                                        </li>
                                                    )}
                                                </ul>
                                            </li>
                                        )}
                                    </ul>
                                </li>
                            )}
                        </ul>
                    </div>
                    <div class="w-full panel bg-harif-800 text-white rounded">
                        <div class="h-8 border-b border-harif-900 text-white px-2 flex items-center text-sm">
                            <div><span class="text-harif-400 font-bold text-base inline-block w-4 pl-1">3</span>
                                <span class="text-amber-500"><Trans>Scegli Mercati</Trans></span></div>
                        </div>
                        {!!this.state.loading.outcomes && <p class="main-text-color text-center pt-5">
                            <i class="fa text-2xl fa-spin fa-spinner"/>
                        </p>}
                        <ul class="p-3 text-xs">
                            {!!this.state.outcomes && Object.entries(this.state.outcomes).map(
                                ([outcomeid, outcomename]) => <li>
                                    <div>
                                        <label class="flex items-center justify-start">
                                            <InputFilter
                                                type="checkbox"
                                                class=""
                                                checked={this.state.outcomeselection.indexOf(outcomeid) !== -1}
                                                onInput={e => this.outcomeSelectionToggle(outcomeid)}
                                            />
                                            <span class="main-text-color w-full py-1 px-2">
												<span class="main-color inline-block font-bold">{outcomeid}</span>
												<span class="inline-block pl-2">{outcomename}</span>
											</span>
                                            <span
                                                class="text-right font-bold font-mono main-color">{this.printOutcomePosition(outcomeid)}</span>
                                        </label>
                                    </div>
                                </li>)}
                        </ul>
                    </div>
                </div>
            </div>
        </div>;
    }
}